export enum GridWellBoundary {
  None = 0,
  ExactStart = 1,
  NearStart = 2,
  ExactStop = 3,
  NearStop = 4,
}

export const OPTIMIZATION_DROP_NUMBER = 1;
export const GRID_LAYER_BASE_NAME = 'Grid Layer';
export const PROTEIN_LAYER_BASE_NAME = 'Protein Layer';

export const GRID_OPTIMIZATION_WARNING_HEADER =
  'The newly-created grids may not have optimized as expected; please check the resulting grids.';
export const MSG_MULTIPLE_START_WELLS = 'More than one well specified as the start.';
export const MSG_MULTIPLE_STOP_WELLS = 'More than one well is marked as the stop.';
export const MSG_RANDOM_CONCENTRATION =
  'Concentration optimization was not applied because the concentration values are in random order.';
export const MSG_RANDOM_PH =
  'pH optimization was not applied because the pH values are in random order.';
export const MSG_START_CONCENTRATION_NOT_SCORED = 'Start concentration was not scored.';
export const MSG_STOP_CONCENTRATION_NOT_SCORED = 'Stop concentration was not scored.';
export const MSG_START_PH_NOT_SCORED = 'Start pH was not scored.';
export const MSG_STOP_PH_NOT_SCORED = 'Stop pH was not scored.';

export const DEFAULT_GRID_OPTIMIZATION_CONFIG = {
  gridWellsEnabled: false,
  groupName: '',
  startName: '',
  stopName: '',
  startNearName: '',
  stopNearName: '',
  maxNumRows: 0,
  maxNumColumns: 0,
};
